<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <router-link to="/students"><v-icon class="text-white pr-2 left">keyboard_arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit Student</div>
      </v-toolbar>
      <v-card class="pa-2 no-shadow grey lighten-5">
            <v-layout wrap>
              <!--<span class="f-20 textColor font-weight-bold">Create New Student</span>-->
              <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Personal info</div>
              <v-flex xs12 lg4 class="pl-2">
                  <v-img :src="user.image_preview" class="shadow-1 cercle" height="150" width="150"></v-img>
                  <v-btn color="grey" @click="onPickImage('profile')" class="shadow-1 ma-0 my-2 text-white card-r">Change Profile image</v-btn>
              </v-flex>

              <input
                type="file"
                style="display:none"
                ref="imageInput"
                accept="image/png"
                @change="OnImagePicked"
              >

              <v-flex xs12 lg8 class="pl-2">
                <v-img size="36px" :src="user.cover_image_preview" class="CoverPhoto card-r"></v-img>
                <v-btn color="grey" @click="onPickImage('cover')" class="shadow-1 ma-0 my-2 text-white card-r">Change Cover image</v-btn>
              </v-flex>
              <v-flex xs12 lg4>
                <v-text-field
                  required
                  color="#749DBF"
                  type="text"
                  placeholder="First Name"
                  class="textFeald"
                  solo
                  label="Full Name"
                  v-model="user.firstName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg4>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="user.dob"
                  lazy
                  transition="scale-transition"
                  persistent
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    placeholder="Birthday"
                    solo
                    required
                    slot="activator"
                    v-model="user.dob"
                    label="Birthday"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="user.dob"
                    :max="this.$root.getDaisableDate(16)"
                    :min="this.$root.getDaisableDate(90)"
                    no-title scrollable >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.menu.save(user.dob)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 lg4>
                <v-text-field
                  required
                  color="#749DBF"
                  class="textFeald"
                  solo
                  label="Club name"
                  placeholder="Club name"
                  v-model="user.clubName"
                  disabled
                ></v-text-field>
              </v-flex>

              <v-flex xs12 lg6 offset-xs0 class="mb-3">
                <v-flex xs12 class="shadow-1 white">
                  <div class=" ml-2 f-12 text-xs-left textColor w-100  text-left">Gender</div>
                  <v-radio-group
                    v-model="user.gender"
                    style="margin-bottom: -23px!important;"
                    row
                    class="ma-0 pl-2"
                  >
                    <v-radio color="primary" label="Male" value="male"></v-radio>
                    <v-radio color="primary" label="Female" value="female"></v-radio>
                    <v-radio color="primary" label="Non-binary" value="non_binary"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-flex>
              <v-flex xs12 lg6 class="mb-3">
                <v-flex xs12 class="shadow-1 white">
                  <div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-8 pt-2">Address</div>
                  <vue-dawa
                    @select="selectItem($event, 'address')"
                    :val="address.oneLineAddress"
                    :showMax="5"
                    containerId="amdinAddress_container"
                    fieldId="amdinAddress_id"
                    fieldName="amdinAddress_name"
                    placeholder="Address"
                  >
                  </vue-dawa>
                </v-flex>
              </v-flex>
              <v-flex xs12 lg4>
                <v-text-field
                  required
                  color="#749DBF"
                  class="textFeald"
                  solo
                  prefix="+45"
                  maxlength="8"
                  label="Phone Number"
                  placeholder="Phone Number"
                  :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                  v-model="user.phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg4>
                <v-text-field
                  required
                  color="#749DBF"
                  class="textFeald"
                  solo
                  label="Email"
                  placeholder="Email"
                  v-model="user.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg4>
              <v-text-field
                    required
                    color="#749DBF"
                    class="textFeald"
                    type="password"
                    solo
                    label="Password"
                    :rules="passwordRule"
                    placeholder="Password"
                    v-model="user.password"
                  ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12>
              <v-text-field
                required
                color="#749DBF"
                class="textFeald date"
                type="date"
                solo
                v-model="birthday"
              ></v-text-field>
              </v-flex>-->


              <!-- <span class="f-15 textColor font-weight-bold">Select Package</span>
              <v-flex md12 sm12 xs12 class="">
                <v-select
                  :items="packages"
                  item-text="name"
                  item-value="id"
                  v-model="selectedPackage"
                  class="input-group--focused"
                ></v-select>
              </v-flex> -->
              <!-- <span class="f-15 textColor font-weight-bold">Select Teacher</span>
              <v-flex md12 sm12 xs12 class="">
                <v-select
                  :items="teachers"
                  item-text="name"
                  item-value="id"
                  v-model="selectedTeacher"
                  class="input-group--focused"
                  label="Select Teacher"
                ></v-select>
              </v-flex> -->


              <!--<span class="f-30"> Insert text editor here </span>-->
            </v-layout>
         <v-alert
            v-if="alert.type=='success'"
            :value="true"
            color="success"
            icon="check_circle"
            outline
          >
            {{alert.msg}}
          </v-alert>
         <v-alert
            v-if="alert.type=='warning'"
            :value="true"
            color="error"
            icon="warning"
            outline
          >
            {{alert.msg}}
          </v-alert>
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-circular>
        <v-card-actions class>
          <v-spacer></v-spacer>
          <v-btn class="grey text-white card-r" to="/students">cancel</v-btn>
          <v-btn
            class="card-r text-white"
            color="primary darken-2"
            @click="UpdateUser"
          >Save</v-btn>
        </v-card-actions>
        </v-card>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import Datepiker from "../Datepicker";
import { mapState, dispatch } from "vuex";
import VueDawa from "vue-dawa";
import api from '../../../utils/backend-api.js'
import axios from 'axios'
import router from '@/router'



export default {
  name: "EditStudent",
  data: () => ({
    tab: null,
    coverPhoto: "https://s3.amazonaws.com/stg-drivers-license-assistance.org/images/blog/find-driving-teacher.jpg",
    address: {
      oneLineAddress: ""
    },
    menu:'',
    user: {
      firstName: "",
      lastName: "",
      phone: "",
      role: 'student',
      dob: "",
      address: {
        oneLineAddress: ""
      },
      gender: "",
      clubName: "",
      email: "",
      password: "",
      termAccept: "",
      zip:"",
      image_preview:'',
      image:'',
      cover_image_preview:'',
      cover_image:''
    },
    teacherClasses: {},
    counter: 0,
    seen: true,
    show: true,
    // yourValue: '',
    date: null,
    disabledDates: {
      to: new Date(Date.now() - 8640000)
    },
    birthday: false,
    type: ["Student", "Teacher"],
    gender: ["male", "female","non-binary"],
    timeslot: [
      "07:00 am",
      "08:00 am",
      "09:00 am",
      "10:00 am",
      "11:00 am",
      "12:00 pm",
      "01:00 pm",
      "02:00 pm",
      "03:00 pm",
      "04:00 pm",
      "05:00 pm",
      "06:00 pm"
    ],
    workMin: [
      "60 min",
      "120 min",
      "180 min",
      "240 min",
      "300 min",
      "360 min",
      "420 min",
      "480 min"
    ],
    breakmin: ["15 min", "30 min", "45 min", "60 min"],
    passwordRule: [
      v => !!v || "Password is required",
      v => v.length >= 6 || "Password must be more than 6 characters"
    ],
    packages:[],
    teachers:[],
    selectedPackage:'',
    selectedTeacher:'',
    alert:{
      type:'',
      msg:'',
    },
    loading:false,
    image_for:'',
    temp:{
      temp_preview:[]
    }
  }),
  watch: {},
  mounted() {

      this.StudentId = this.$route.params.id;
      Store.dispatch("studentdetails/getStudentById", this.StudentId).then(res => {

      });
      setTimeout(() => {
          this.user.image_preview =Store.state.studentdetails.studentdetails.image;
          this.user.cover_image_preview =Store.state.studentdetails.studentdetails.cover_image;
          this.user.firstName =Store.state.studentdetails.studentdetails.name;
          this.user.email =Store.state.studentdetails.studentdetails.email;
          this.user.phone =Store.state.studentdetails.studentdetails.phone;
          this.user.dob =Store.state.studentdetails.studentdetails.dob;
          this.user.gender =Store.state.studentdetails.studentdetails.gender;
          this.address.door =Store.state.studentdetails.studentdetails.door;
          this.address.floor =Store.state.studentdetails.studentdetails.floor;
          this.address.city =Store.state.studentdetails.studentdetails.city;
          this.address.street =Store.state.studentdetails.studentdetails.street;
          this.address.streetNumber =Store.state.studentdetails.studentdetails.streetNumber;
          this.address.zipCode =Store.state.studentdetails.studentdetails.zipCode;
          this.address.oneLineAddress =this.nullCheck(this.address.street)+this.checkComma(this.address.street)+this.nullCheck(this.address.streetNumber)+this.nullCheck(this.address.floor)+this.nullCheck(this.address.door)+this.nullCheck(this.address.zipCode)+this.nullCheck(this.address.city);
          this.zipCode =Store.state.studentdetails.studentdetails.zip;
          this.role=Store.state.studentdetails.studentdetails.role;
          this.package_id =this.selectedPackage;
          this.teacher_id =this.selectedTeacher;
          this.club_id = Store.state.user.club_id;

          // this.classPrice =this.$store.state.Modules.modules.price;
          // this.internalPrice =this.$store.state.Modules.modules.internal_price;
          // this.description =this.$store.state.Modules.modules.description;
            // this.image =this.$store.state.Modules.modules.attachment.galleries;

      }, 3500);
  },
  created() {
    axios.get("http://192.168.1.3:1116/api/student/viewBookedPackage")
    this.user.clubName=Store.state.user.club_name
    Store.dispatch('Packages/getAllPackages').then(res=>{
        setTimeout(() => {
          var studentdetails=Store.state.studentdetails
          for(var x=0;x<studentdetails.length;x++){
            var value1={
              id:TeachersData[x].id,
              name:TeachersData[x].name
            }
            this.teachers.push(value1)
          }
        }, 1500);

    })
    Store.dispatch("Teachers/getAllTeachers")
  },
  updated: () => {},
  methods: {
      onPickImage(image_for) {
        this.image_for=image_for
				this.$refs.imageInput.click();
			},
			OnImagePicked(event) {
        this.temp.temp_preview=[]
				const files = event.target.files;
				let fileName = files[0].name;
				// this.club.club_logo = fileName;
        console.log(files[0])
				if (fileName.lastIndexOf(".") <= 0) {
					// return alert("Please add a valid file! ");
          return
				}else if(files[0].size>1500000){
          return alert("Size")
        }
			  const fileReader = new FileReader();
        let self=this
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          self.temp.temp_preview.push(fileReader.result)
          // console.log(fileReader.result)
        });
        setTimeout(()=>{
            console.log(this.temp)
            // debugger
            if(this.image_for=='profile'){
              // debugger
              this.user.image=files[0]
              this.user.image_preview=this.temp.temp_preview[0]
            }else if(this.image_for=='cover'){
              this.user.cover_image=files[0]
              this.user.cover_image_preview=this.temp.temp_preview[0]
            }
        },400);

				// this.club.club_logo = files[0];
				// this.club.club_logo_name = files[0].name;
    },
    checkComma(value){
      if(value){
          return ','
      }else{
        return ''
      }
    },
    nullCheck(value){
      if(value){
        return value+' ';
      }else{
        return ""
      }
    },
    UpdateUser() {
          this.loading=true
          this.StudentId = this.$route.params.id;
          var Student = {
            name: this.user.firstName+' '+this.user.lastName,
            email: this.user.email,
            phone: this.user.phone,
            dob: this.user.dob,
            // address: this.address.oneLineAddress,
            city: this.address.city,
            street: this.address.street,
            streetNumber: this.address.streetNumber,
            floor: this.address.floor,
            door: this.address.door,
            // state: this.address.state,
            zipCode: this.address.zipCode,
            gender: this.user.gender,
            role: 'student',
            password: this.user.password,
            // door: this.address.door,
            // floor: this.address.floor,
            // street: this.address.street,
            // streetNumber: this.address.streetNumber,          // package_id:this.selectedPackage,
            // club_id:Store.state.user.club_id,
            // teacher_id:this.selectedTeacher,
            image:this.user.image,
            cover_image:this.user.cover_image
        };
        let formData=new FormData()
        formData.append('email',this.user.email)
        formData.append('phone',this.user.phone)
        formData.append('dob',this.user.dob)
        formData.append('city',this.address.city)
        formData.append('street',this.address.street)
        formData.append('streetNumber',this.address.streetNumber)
        formData.append('floor',this.address.floor)
        formData.append('door',this.address.door)
        formData.append('zipCode',this.address.zipCode)
        formData.append('gender',this.user.gender)
        formData.append('role',this.user.role)
        formData.append('password',this.user.password)
        formData.append('image',this.user.image)
        formData.append('cover_image',this.user.cover_image)

        var StudentId=this.StudentId
        var Data={
          "StudentDetails":formData,
          "StudentId":this.StudentId
        }
          // this.$store.dispatch("Students/studentEdit", Data).then(res => {
          //   console.log(res)
          // });
          // studentEdit ({commit}, Data) {
            // return new Promise(function (resolve, reject) {
            api.postData('admin/student/' + Data.StudentId, Data.StudentDetails)
            .then(res => {

              console.log(res)
              if(res.status==201){
                this.loading=false
                this.alert.type="success"
                this.alert.msg="successfully updated"

                setTimeout(() => {
                  this.$router.push('/students')
                }, 500);

              }
              this.$store.dispatch('Student/setStudentsData', res.Data)
            }).catch((error) => {
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="Check your informations"
            })
    },
    selectItem(payload, objectName) {
      this.$set(this, objectName, this.translateData(payload));
      this.newUser.user.address = this.translateData(payload);
    },
    translateData(address) {
      if (!address || !address.data) {
        return;
      }
      return {
        id: address.data.id,
        street: address.data.vejnavn,
        streetNumber: address.data.husnr,
        floor: address.data.etage,
        door: address.data.dør,
        zipCode: address.data.postnr,
        city: address.data.postnrnavn,
        oneLineAddress: address.tekst,
        village : address.Tversted
      };
    }
  },
  components: {
    VueDawa,
    Datepiker
  },
  computed: {
    ...mapState({
      studentdetails: Students => Store.state.studentdetails
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/student/EditStudent.vue